import { render } from "./AtRiskPanel.vue?vue&type=template&id=d18e1e4a&scoped=true"
import script from "./AtRiskPanel.vue?vue&type=script&lang=js"
export * from "./AtRiskPanel.vue?vue&type=script&lang=js"

import "./AtRiskPanel.vue?vue&type=style&index=0&id=d18e1e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18e1e4a"]])

export default __exports__